import { Link } from 'react-router-dom'
import type { LucideIcon } from 'lucide-react'

type Props = {
  title: string
  icon?: LucideIcon
  to: string
  glow?: boolean
}

export function BimssServiceTile({ title, icon: Icon, to, glow }: Props) {
  return (
    <Link
      to={to}
      className={`aspect-square rounded-2xl border-2 bg-card flex flex-col items-center justify-center gap-2 px-3 py-4 transition-all active:scale-95 ${
        glow
          ? 'border-red-500 shadow-[0_0_12px_rgba(220,38,38,0.5)] animate-pulse hover:shadow-[0_0_20px_rgba(220,38,38,0.7)]'
          : 'border-input hover:border-red-500 hover:bg-red-50/50'
      }`}
    >
      {Icon && <Icon className="h-8 w-8 text-red-600" />}
      <span className="text-center text-sm font-bold text-red-600 leading-tight">
        {title}
      </span>
    </Link>
  )
}
